import styled from "styled-components";

export const LeftButtonSection = styled.div``;

export const TableWrapper = styled.div`
  padding-left: 20px;
  padding-right: 20px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 65px;
`;
